export interface NewOrTrackingState {
  newOrTracking: string | null;
}

export const InitialState: NewOrTrackingState = {
  newOrTracking: null,
};
